<template>
  <v-data-table
    :headers="headers"
    :items="canEndInspections"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="CanEndInspection-button-new"
          @click="$router.push({
            name: 'processing-EditCanEndInspection'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditCanEndInspection',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCanEndInspection',
  module: 'CanEndInspection',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('canEndInspections', ['canEndInspections']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('supplier'),
          value: 'supplier',
        },
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_canEndInspections();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canEndInspections', ['LOAD_canEndInspections', 'DELETE_canEndInspection']),
    /** Delete CanEndInspection from the collection
     */
    async remove(CanEndInspection) {
      this.isLoading = true;
      await this.DELETE_CanEndInspection(CanEndInspection);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# CanEndInspection example

'''js
<CanEndInspection />
'''
</docs>
